import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Button, Grid} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import AddUserDefinedNotes from '../../../../components/AddUserDefinedNotes';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';
import DialogBox from './../../../../components/DialogBox';
import SearchNotesForm from '../../../../components/SearchNotes/searchNotesForm';
import {postSystemNotes, resetSystemNotes} from '../../../../redux/reducers/WorkQueueSetup';
import {SuccessSnackbar} from '../../../../components/CustomSnackBar';

const WorkQueueNotes = ({
  open,
  dialogClose,
  title,
  maxWidth,
  value,
  handleSubmit,
  condition,
  buttonCondition,
  reportCodeData,
  workQueueCodeData,
  workQueue,
}) => {
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const {systemNotesStatus, isSystemNoteLoading, notesSuccessMsg} = useSelector(
    ({addWorkQueue}) => addWorkQueue,
  );
  useEffect(() => {
    if (systemNotesStatus === 200) {
      tableRef?.current && tableRef.current.onQueryChange();
      handleDialogClose();
      setTimeout(() => {
        // dispatch(ResetMessage());
        dispatch(resetSystemNotes());
      }, 3000);
    }
  }, [systemNotesStatus]);

  useEffect(() => {
    if (submit) {
      tableRef?.current?.onQueryChange();
    }
  }, [submit, searchData]);

  const dispatchRecordFormatSystemNotes = (data) => {
    dispatch(
      postSystemNotes({
        code: workQueueCodeData ? workQueueCodeData?.workqueueName : '',
        noteText: data,
        workqueueId: workQueueCodeData ? workQueueCodeData?.workqueueId : '',
      }),
    );
  };
  let transcription = '';
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        // minWidth: "550px",
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created By',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  // const { roleData } = useSelector(({ role }) => role);
  //   const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE?.add;
  // const workQueueSetupAccess = roleData?.window?.[WORK_QUEUE_SETUP]?.WQS?.add;
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  return (
    <>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={isSystemNoteLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            disableByRoleAccess={'enable'}
          />
        )}
      </DialogBox>

      <Grid className="system-notes-dialog">
        <SearchNotesForm
          setSearchData={setSearchData}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          workQueueCodeData={workQueueCodeData}
          workQueue={workQueue}
          moduleName={'report'}
        />
        <div className="custom-table new-standard-textfields custom-toolbar-icons custom-actions-icon global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `workqueuesetup/find/all/wqnotes`;
                const bodyObj = {
                  code: workQueueCodeData?.workqueueName,
                  limit: rows,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  search: '',
                  frameworkId: workQueueCodeData?.workqueueId ? workQueueCodeData?.workqueueId : 0,
                  noteDate: searchData?.noteDate ?
                    moment(searchData?.noteDate).format('MM/DD/YYYY') :
                    '',
                  noteText: searchData?.noteText ? searchData?.noteText : '',
                  noteType: searchData?.noteType?.key ? searchData?.noteType?.key : '',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!workQueueCodeData?.workqueueName) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            actions={[
              {
                icon: () => (
                  <div>
                    <Button
                      variant="outlined"
                      className="search-btn"
                      // disabled={workQueue && !workQueueSetupAccess}
                    >
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                // disabled: workQueue && !workQueueSetupAccess,
                isFreeAction: true,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: true,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
      {notesSuccessMsg && <SuccessSnackbar successMsg={notesSuccessMsg} />}
    </>
  );
};

export default WorkQueueNotes;
